import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { DadosAdicionaisModelo } from "../models/dados-adicionais-modelo.model";

@Injectable()
export class DadosAdicionaisModeloService extends BaseService<DadosAdicionaisModelo>{

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/dados-adicionais-modelo';
  }

  public clone(id: number, obj: any): Observable<any> | any {
    return this.http.post<any>(this.baseUrl + "/clone/" + id, obj, { headers: this.headers });
  }

  public listOrgao(): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/list-orgao", { headers: this.headers });
  }

  public listQuestion(): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/list-question", { headers: this.headers });
  }
}